import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: false,
    error: false,
    errorMessage: "",
    success: false,
    isGetLoading: true,
};

export const AtsInterviewDetailsReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ATS_INTERVIEW_DETAILS_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                isGetLoading: true,
                error: false,
                success: false
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                isGetLoading: false,
                successMessage: action.payload?.message,
                atsInterviewDetailsData: action.payload?.data?.data
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                isGetLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                atsInterviewDetailsData: action.payload?.data?.data
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                atsInterviewDetailsData: action.payload?.data?.data
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
            case ActionTypes.ATS_INTERVIEW_DETAILS_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                atsInterviewDetailsData: action.payload?.data?.data
            };
        case ActionTypes.ATS_INTERVIEW_DETAILS_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}